import FlumpObject from "./FlumpObject";
import { SafeUtils, audioPlayer } from "../../PhaserExtension";

export default class FlumpButton extends FlumpObject
{
    constructor(game, config, library)
    {
        super(game, config, library);

        this.keys.down = this.keys.down || this.keys.idle;
        this.keys.over = this.keys.over || this.keys.idle;
        this.highlightLength = SafeUtils.getElse([this.config, "highlightLength"], 3000);

        this.onClicked = new Phaser.Signal();

        this.events.onInputDown.add(this._onInputDown, this);
        this.events.onInputOver.add(this._onInputOver, this);
        this.events.onInputOut.add(this._onInputOut, this);
        this.events.onInputUp.add(this._onInputUp, this);

        this.inputEnabled = true;
        this.input.useHandCursor = true;

        if(this.config.highlightTriggers)
        {
            audioPlayer.onSoundPlayed.add(this._onSoundPlayed, this);
        }
    }

    _onSoundPlayed(key)
    {
        // only highlight if the button is enabled
        if(!this.inputEnabled) return;

        for(let i = 0; i < this.config.highlightTriggers.length; i++)
        {
            if(this.config.highlightTriggers[i] === key)
            {
                this._onHighlight();
                return;
            }
        }
    }

    _onInputDown()
    {
        this.loop(this.keys.down, true);
    }

    _onInputOver()
    {
        this.loop(this.keys.over, true);
    }

    _onInputOut()
    {
        this.loop(this.keys.idle, true);
    }

    _onInputUp()
    {
        if(this.config.sound)
        {
            audioPlayer.play(this.game, this.config.sound);
        }

        this.loop(this.keys.idle, true);
        this.onClicked.dispatch();
    }

    _onHighlight()
    {
        if(this.inputEnabled)
        {
            this.loop(this.keys.highlight, true, true);
            this.game.time.events.add(this.highlightLength, this._onHighlightEnd, this);
        }
    }

    _onHighlightEnd()
    {
        if(this.display.currentClip.name == this.keys.highlight)
        {
            this.loop(this.keys.idle, true);
        }
    }

    destroy(children = true)
    {
        this.onClicked.dispose();
        audioPlayer.onSoundPlayed.remove(this._onSoundPlayed, this);
        super.destroy(children);
    }
}
